<div class="container-fluid">
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Filtres
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="form-group">
        <mat-form-field>
          <input matInput [(ngModel)]="filterName" (change)="updateDataFromFilters()" placeholder="Filtre" />
        </mat-form-field>
        <mat-form-field class="m-1">
          <mat-label>Connecteurs</mat-label>
          <mat-select [(value)]="filterConnector" (valueChange)="updateDataFromFilters()">
            <mat-option>Tous</mat-option>
            <mat-option value="KWFRANCE">KW France</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-divider></mat-divider>
  <div class="table-container">
    <div class="loading" *ngIf="isLoadingResults">
      <mat-spinner></mat-spinner>
    </div>
    <table mat-table [dataSource]="data" matSort matSortActive="created" matSortDisableClear matSortDirection="desc">
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef>Connecteur</th><!-- reactivate mat-sort-header when managed by the api-->
        <td mat-cell *matCellDef="let row" class="main">{{ row.config.code }}</td>
      </ng-container>
      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef>Utilisateur</th>
        <td mat-cell *matCellDef="let row">{{ row.user }}</td>
      </ng-container>
      <ng-container matColumnDef="configurationDate">
        <th mat-header-cell *matHeaderCellDef>Date de configuration</th>
        <td mat-cell *matCellDef="let row">{{ row.config.configurationDate | dateTimeFormat }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator [length]="resultsLength" [pageSize]="paging.pagingPageSize"
    [pageSizeOptions]="paging.pagingPageSizeOptions" showFirstLastButtons></mat-paginator>
</div>
